import FIELD_BUILDER_MAP from './fieldBuilderMap';

function FormField(props) {
  const {
    field, field: { type }, error, ...rest
  } = props;
  const builder = FIELD_BUILDER_MAP[type];

  return builder ? builder({ field: { ...field, error }, ...rest }) : null;
}

export default FormField;
